import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './NotificationButtons.module.scss';
import cn from 'classnames';
import { markAsRead, NOTIFICATION_TYPE, REQUEST_STATUS } from '../../../store/reducers/Notifications/slice';
import { approveInvite, disapproveInvite } from '../../../store/reducers/Social/slice';
import { useAppDispatch } from '../../../store/reducers';
import { ReactComponent as AcceptFriend } from '../../../assets/icons/accept-friend.svg';
import { ReactComponent as DeclineFriend } from '../../../assets/icons/decline-friend.svg';
import { ReactComponent as MarkRead } from '../../../assets/icons/mark-read.svg';
import { acceptRequest, declineRequest } from '../../../store/reducers/Guild/race';
const NotificationButtons = ({ notification, className }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { invite, type, guildRequest } = notification;
    const buttons = useMemo(() => {
        const buttons = [];
        if (!notification.isRead) {
            buttons.unshift({
                name: 'mark-read',
                icon: _jsx(MarkRead, {}),
                action: () => notification.id && dispatch(markAsRead([notification.id]))
            });
        }
        if (type === NOTIFICATION_TYPE.NEW_INVITATION &&
            (invite === null || invite === void 0 ? void 0 : invite.status) === REQUEST_STATUS.PENDING) {
            buttons.unshift({
                name: 'accept-friend',
                icon: _jsx(AcceptFriend, {}),
                action: () => invite &&
                    dispatch(approveInvite({
                        inviteId: invite.id,
                        address: invite.from.address,
                        notificationId: notification.id
                    }))
            }, {
                name: 'decline-friend',
                icon: _jsx(DeclineFriend, {}),
                action: () => invite &&
                    dispatch(disapproveInvite({
                        inviteId: invite.id,
                        notificationId: notification.id
                    }))
            });
        }
        if (type === NOTIFICATION_TYPE.GUILD_REQUEST &&
            (guildRequest === null || guildRequest === void 0 ? void 0 : guildRequest.status) === REQUEST_STATUS.PENDING) {
            buttons.unshift({
                name: 'accept-friend',
                icon: _jsx(AcceptFriend, {}),
                action: () => {
                    var _a;
                    return guildRequest &&
                        dispatch(acceptRequest({
                            requestId: guildRequest.id,
                            guildId: (_a = guildRequest.to) === null || _a === void 0 ? void 0 : _a.id,
                            notificationId: notification.id
                        }));
                }
            }, {
                name: 'decline-friend',
                icon: _jsx(DeclineFriend, {}),
                action: () => {
                    var _a;
                    return guildRequest &&
                        dispatch(declineRequest({
                            requestId: guildRequest.id,
                            guildId: (_a = guildRequest.to) === null || _a === void 0 ? void 0 : _a.id,
                            notificationId: notification.id
                        }));
                }
            });
        }
        return buttons;
    }, [invite, guildRequest, notification.isRead]);
    return (_jsx("div", Object.assign({ className: cn(styles.element, className, 'd-flex flex-nowrap') }, { children: buttons.map(({ name, icon, action }) => (_jsx("div", Object.assign({ className: styles.item, onClick: action }, { children: icon }), name))) })));
};
export default NotificationButtons;
